import $ from "jquery";
(function ($) {
    $(document).ready(function() {
        // Entoure les <h2> d'une <div> afin de permettre la décoration ISO Maquette
        $('.heading--decorated').wrap('<div class="heading--decoration"></div>');
        $('<svg class="svg-left" viewBox="0 0 70 2" xmlns="http://www.w3.org/2000/svg">  <path d="M838.97 1860.19H1086" style="fill:none;stroke:#000;stroke-width:1.36px" transform="matrix(.27329 0 0 1 -228.381 -1859.29)"/></svg>').insertBefore('.heading--decorated');
        $('<svg class="svg-right"  viewBox="0 0 70 2" xmlns="http://www.w3.org/2000/svg">  <path d="M838.97 1860.19H1086" style="fill:none;stroke:#000;stroke-width:1.36px" transform="matrix(.27329 0 0 1 -228.381 -1859.29)"/></svg>').insertAfter('.heading--decorated');

        // Ajout d'une classe si <h2> décoré choisi dans les sections text et images
        let heading = $('.text-image-section.text-image-section--image-left .heading--decoration');
        heading.parent().addClass('heading-text-image-right');
    });
})(jQuery);